import ViewPadrao from "../views/ViewPadrao";
import TipoDocumentoList from "../views/TipoDocumentoList";
import TipoDocumentoCad from "../views/TipoDocumentoCad";
import TipoProprietarioDocList from "../views/TipoProprietarioDocList";
import TipoProprietarioDocCad from "../views/TipoProprietarioDocCad";

export default {
  path: "parametros",
  component: ViewPadrao,
  children: [
    {
      path: "tipos-documento",
      component: ViewPadrao,
      children: [
        {
          path: "",
          name: "tipo-documento-list",
          component: TipoDocumentoList,
          meta: {
            auth: true,
            perms: ["params.tipos_documento"],
          },
        },
        {
          path: "novo",
          name: "tipo-documento-formulario",
          component: TipoDocumentoCad,
          meta: {
            auth: true,
            perms: ["params.tipos_documento"],
          },
        },
        {
          path: "editar/:id",
          name: "tipo-documento-formulario-editar",
          component: TipoDocumentoCad,
          meta: {
            auth: true,
            perms: ["params.tipos_documento"],
          },
        },
      ],
    },
    {
      path: "tipos-proprietario-doc",
      component: ViewPadrao,
      children: [
        {
          path: "",
          name: "tipo-proprietario-doc-list",
          component: TipoProprietarioDocList,
          meta: {
            auth: true,
            perms: ["params.tipos_proprietario_doc"],
          },
        },
        {
          path: "editar/:id",
          name: "tipo-proprietario-doc-formulario-editar",
          component: TipoProprietarioDocCad,
          meta: {
            auth: true,
            perms: ["params.tipos_proprietario_doc"],
          },
        },
      ],
    },
  ],
};
